<template>
  <div class="bloco">
    <slot></slot>
  </div>
</template>

<script>
    export default {
        name: "Bloco"
    }
</script>



// WEBPACK FOOTER //
// src/components/Widgets/Bloco.vue